import ManagementDetails from "./ManagementDetails";

export default ManagementDetails;
